import { IComponentController } from 'angular';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IFormulaireGroupeAccordeonClass } from '../../../../../core/services/formulaire/formulaire-groupe-accordeon.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IFormulaireItemDividerClass } from '../../../../../core/services/formulaire/formulaire-item-divider.service';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IFormulaireItemMenuItemClass } from '../../../../../core/services/formulaire/formulaire-item-menu-item.service';

interface IPageDo0065 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    ofcMultiOccurrenceOptions: IMultiOccurrenceOptions;
    formulaireCriteres: IFormulaire;
}


/* @ngInject */
export default function Do0065Controller(
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    FormulaireGroupeAccordeon: IFormulaireGroupeAccordeonClass,
    FormulaireItemMenuItem: IFormulaireItemMenuItemClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    FormulaireItemDivider: IFormulaireItemDividerClass,
    Menu: IMenuClass,
    MenuItemAction: IMenuItemActionClass,
    MenuItemForage: IMenuItemForageClass,
    do0066Route: IRoute,
    mr1004Route: IRoute
) {
    const vm: IPageDo0065 = this;

    const forageDO0066Can = new MenuItemForage(
        'LBL_66CAN',
        do0066Route.NAME,
        (data) => ({
            caecleint: data.caecleint
        }),
        {
            icon: 'exit_to_app',
            directionTooltip: 'BOTTOM'
        }
    );

    const forageDO0066Emp = new MenuItemForage(
        'LBL_66EMP',
        do0066Route.NAME,
        (data) => ({
            caecleint: data.caecleint
        }),
        {
            icon: 'exit_to_app',
            directionTooltip: 'BOTTOM',
            hidden: (data: any) => data.eplnummat === null
        }
    );




    vm.monoOccurrenceOptions = {
         fonctions: {
            boutonDupliquer: false
        },
        formulaire: new Formulaire('LBL_CANETU',[
            new FormulaireItem('caenumdoc', {
                largeur: 15
            }),
            new FormulaireItem('caedatsou', {
                largeur: 15
            }),
            new FormulaireItem('caenummat', {
                largeur: 15, menu: [forageDO0066Can]
            }),
            new FormulaireItem('eplnummat', {
                largeur: 15, menu: [forageDO0066Emp]
            }),
            new FormulaireItem('nomprnusu', {
                largeur: 25
            }),
            new FormulaireItem('caesex', {
                largeur: 15
            }),
            new FormulaireItem('caeflgimm', {
                largeur: 15
            }),
            new FormulaireItem('caecomcan', {
                largeur: 36
            }),
            new FormulaireItem('caecom', {
                largeur: 36
            }),
            new FormulaireItemMenuItem(new MenuItemForage(
                    '',
                    mr1004Route.NAME,
                    (data) => ({
                        // stamnetab: 'EVC',
                        evrcleintref: data.caecleint,
                        caenumdoc: data.caenumdoc,
                        eplnummat: data.eplnummat,
                        nomprnusu: data.nomprnusu,
                        caenummat: data.caenummat
                    }),
                    {
                    disabled : (data: any) => data.nbrevr === 0,
                    compteur: (data: any) => data.nbrevr, 
                    class: 'md-mini md-accent md-hue-1',
                    secondaire: true,   
                    icon: "mail"                    
                }
                ), { largeur: 10 }),
            new FormulaireGroupeAccordeon('LBL_ACCORDEON_ADRESSE', new Formulaire([
                new FormulaireItem('caeadrl01', { largeur : 30 }),
                new FormulaireItem('caeadrl02', { largeur : 30 }),
                new FormulaireItem('caeadrl03', { largeur : 30 }),
                new FormulaireItem('caevil', { largeur : 30 }),
                new FormulaireItem('vacsysreg', { largeur : 30 }),
                new FormulaireItemSautDeLigne(),
                new FormulaireItem('caepay', { largeur : 30 }),
                new FormulaireItem('caepro', { largeur : 30 }),
                new FormulaireItem('caecodpos', { largeur : 30 }),
            ], {
                largeurDefaut: 50
            })),
            new FormulaireGroupeAccordeon('LBL_ACCORDEON_TELCOU', new Formulaire([
                new FormulaireItem('caenumtel', { largeur : 30 }),
                new FormulaireItem('caenumtelbur', { largeur : 30 }),
                new FormulaireItem('caenumtelposbur', { largeur : 30 }),
                new FormulaireItem('caeadrcou', { largeur : 30 }),
            ], {
                largeurDefaut: 50
            })),
            new FormulaireGroupeAccordeon('LBL_ACCORDEON_AUTINFO', new Formulaire([
                new FormulaireItem('caedatnai', { largeur : 30 }),
                new FormulaireItem('caenas', { largeur : 30 }),

                new FormulaireItemDivider('LBL_INFO_ETRANGER'),
                new FormulaireItem('caenasimm', { largeur : 30 }),
                new FormulaireItem('caedatper', { largeur : 30 }),
                new FormulaireItem('caedatexp', { largeur : 30 })
            ], {
                largeurDefaut: 50
            }),{ hidden: (data) => !data.caenummat}),

        ], { largeurDefaut: 100 }),
    }
    // Emploi
    vm.ofcMultiOccurrenceOptions = {
        colonnesCachees: [
                'color'
            ],
        colonnesVisibles: [  
            { nom: 'ofcflgsel', largeur: 130, changeColor: true },
            { nom: 'ofcflgrej', largeur: 130, changeColor: true },
            { nom: 'ofcflgdes', largeur: 130, changeColor: true },
            { nom: 'ofanum', largeur: 130, changeColor: true },
            { nom: 'crscod', largeur: 130, changeColor: true },
            { nom: 'crsdsc', largeur: 200, changeColor: true },
            { nom: 'cofgrp', largeur: 130, changeColor: true },
            { nom: 'unocod', largeur: 130, changeColor: true },
            { nom: 'unodscabr', largeur: 180, changeColor: true },
            { nom: 'trmcod', largeur: 200, changeColor: true },
            { nom: 'trmdsc', largeur: 130, changeColor: true },            
            { nom: 'temcod', largeur: 130, changeColor: true },
            { nom: 'temdsc', largeur: 130, changeColor: true },
            { nom: 'ofcdatdes', largeur: 130, changeColor: true },
            { nom: 'ofccomint', largeur: 300, changeColor: true }
        ]
    }
}
